import axios from '../axiosConfig';



export const fetchEarningsTitles = async (symbol) => {
    try {
        const response = await axios.get(`/fetch_date_for_latest_transcript/`, {
            params: { symbol },
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch earnings titles:', error);
        throw error;
    }
};


export const fetchCIK = async (symbol) => {
    try {
        const response = await axios.get(`/fetch_cik_for_frontend/`, {
            params: { symbol },
        });
        return response.data.cik;
    } catch (error) {
        console.error('Failed to fetch CIK:', error);
        throw error;
    }
};

